export default function getManageUsersStartCardRoute(user) {
  const { role, schoolDistrict, school, id } = user
  const startRoutes = {
    'Super Administrator': '/users/manage/districts',
    'District Admin': `/users/manage/schools/${schoolDistrict}`,
    'School Admin': `/users/manage/teachers/${school}`,
    'Teacher': `/users/manage/classes/${id}`
  }
  return startRoutes[role]
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/getManageUsersStartCardRoute.js